module.exports = __webpack_public_path__ + "static/media/easi6_privacy_ko.f7d49c82.md";


//////////////////
// WEBPACK FOOTER
// ./src/policies/easi6_privacy_ko.md
// module id = 58
// module chunks = 0